(function(){
  var ENDPOINT = "https://cs.bavasnederland-crm.company/platform-api/atc_ping";
  var SHOP = (window.Shopify && window.Shopify.shop) || "";
  function ping(productId){
    if (!productId || !SHOP) return;
    try {
      fetch(ENDPOINT, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({shop: SHOP, product_id: String(productId)}),
        keepalive: true
      }).catch(function(){});
    } catch(e){}
  }
  // Intercept fetch('/cart/add...') -- dekt zowel /cart/add.js als AJAX-cart-apps.
  var origFetch = window.fetch;
  window.fetch = function(input, init){
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (url.indexOf("/cart/add") !== -1 && init && init.body) {
        var body = init.body;
        if (typeof body === "string") {
          try {
            var parsed = JSON.parse(body);
            if (parsed.id) ping(parsed.id);
            else if (parsed.items && parsed.items.length) parsed.items.forEach(function(i){ ping(i.id); });
          } catch(e){
            var m = body.match(/id=(\d+)/);
            if (m) ping(m[1]);
          }
        } else if (body instanceof FormData) {
          var id = body.get("id");
          if (id) ping(id);
        }
      }
    } catch(e){}
    return origFetch.apply(this, arguments);
  };
  // Fallback: klassieke <form action="/cart/add"> submit (geen JS-cart).
  document.addEventListener("submit", function(e){
    var form = e.target;
    if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
    var idField = form.querySelector('[name="id"]');
    if (idField && idField.value) ping(idField.value);
  }, true);
})();
